import { getHelperDataSpei, postPayoutSpei } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import i18n from '@/utils/i18n';
import { debug } from 'util';

Vue.use(Vuex);

const state = {
  helpers: {},
  payoutStatus: {
    initialize: false,
    loading: false,
    success: false,
    error: false,
  },
};

const mutations = {
  setPayoutStatus(state, row) {
    state.payoutStatus = row;
  },
  setHelpers(state, helpers) {
    state.helpers = helpers;
  },
};
const getters = {};
const actions = {
  tryGetHelpers({ commit }) {
    commit('setPayoutStatus', { initialize: false });
    getHelperDataSpei()
      .then(r => {
        if (r.data.IsSuccess) {
          console.log(r.data.Data);
          commit('setHelpers', r.data.Data);
        }
      })
      .finally(() => {
        commit('setPayoutStatus', { initialize: false });
      });
  },
  tryPayout({ rootState, commit }, payload) {
    payload = {
      ...payload,
      PayoutMethod: rootState.payoutStore.selectedPayoutMethod.pk_mstpayout_method,
      PayoutAmount: rootState.payoutStore.amount,
    };
    commit('setPayoutStatus', { loading: true });
    postPayoutSpei(payload)
      .then(r => {
        if (r.data.IsSuccess) {
          if (r.data.Data.status && r.data.Data.status === 'OK') {
            if (r.data.Data.error_code === 'NEW_PAYOUT') {
              commit('setPayoutStatus', {
                success: i18n.t('Exceptions.Spei.' + r.data.Data.error_code),
              });
              return;
            }
            commit('setPayoutStatus', {
              success: i18n.t('Exceptions.' + r.data.Data.error_code) || r.data.Data.message,
            });
          } else {
            commit('setPayoutStatus', {
              error: r.data.Data.error_code || r.data.Data.message,
            });
          }
        } else {
          commit('setPayoutStatus', { error: 'Payout.SPEI.Error' });
        }
      })
      .catch(() => {
        commit('setPayoutStatus', { error: 'Payout.SPEI.Error' });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
